import { useMemo } from 'react'
import { useGetSetting } from 'api/settings'

export const useGetIsPortalHidden = () => {
  const { setting, loading } = useGetSetting()
  return useMemo(() => {
    return loading ? true : setting?.isPortalHidden
  }, [loading, setting])
}
